import { render, staticRenderFns } from "./BookEdit.vue?vue&type=template&id=10cbe45c"
import script from "../../controllers/book_library/book-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/book_library/book-edit.js?vue&type=script&lang=js&external"
import style0 from "./BookEdit.vue?vue&type=style&index=0&id=10cbe45c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports